export enum InputType {
  PhoneNumber = 0,
  Email = 1,
}
